import defaultConfig from 'config/default-config.yaml'; // URL to versus-br-config.yaml, resolved using alias in webpack

import {mergeTo} from '#core/utils/config-utils.js';

import {configureSportsbook} from '#core/sportsbook-initializer.js';

import {getTokens} from './config/viewsconfig';
import fonts from './config/fonts.yaml';
import {BASE_PALETTE} from './config/theme';
import BadRoutePageView from './pages/bad-route-page-view/index.jsx';
import {removeLegacyTimeOffset} from './migrations/remove-legacy-time-offset.js';

removeLegacyTimeOffset();

function enrichMojitoConfigWithCustom(mojitoConfig) {
    mergeTo(mojitoConfig, {
        services: {
            viewImplementations: {
                BadRoutePageView: {
                    implementation: BadRoutePageView,
                },
            },
        },
    });
}

configureSportsbook({
    enrichMojitoConfigWithCustomFn: enrichMojitoConfigWithCustom,
    getTokensFn: getTokens,
    configuration: {
        ...defaultConfig,
        appearance: {
            BASE_PALETTE,
        },
        fonts,
    },
});
